export const mapboxAddressExpression =
  /(?<line1>[^,]+),\s+(?<city>[^,]+),\s+(?<state>[^,]+)\s+(?<postal_code>\d+)?(,\s+(?<country>.+))?/

export const phoneNumberExpression = /^\+1\s\(\d{3}\)\s\d{3}-\d{4}$/

export const IS_SAFARI = /^((?!chrome|android).)*safari/i
